import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SettingsPanel } from '@/app/domains/admin/layout/ui/settings-panel';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SettingsPanel],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  template: `
    <router-outlet />
    <settings-panel />
  `,
})
export class App {}
